var lists_default = {
  "fontElementMap": "-EH7s",
  "orderedlist": "lNAHs",
  "bulletedlist": "T3-vm",
  "listItem": "syYPV"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
